import { enGB, hi } from 'date-fns/locale';
import type { Locale } from 'date-fns';

const localeMap: Record<string, Locale> = {
  en: enGB,
  hi: hi,
};

/**
 * Returns the date-fns Locale object for the given language code.
 * Falls back to enGB if the language is not mapped.
 */
export function getDateLocale(lang: string): Locale {
  return localeMap[lang] || enGB;
}
